import { ChangeColor } from './ChangeColor';

export class ChangeDarkColor extends ChangeColor {
  type: string = 'ChangeDarkColor';
}
